var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, useEffect, useCallback, useMemo } from 'react';
// @ts-ignore
import { debounce } from 'lodash';
import { FlightSelect, FlightTextInput, FlightSuggestionList } from '@flybits/design-system';
import { CONTENT_ANALYTICS_QUERY_NAMES, CONTENT_ANALYTICS_COMPONENT_QUERY_NAMES, } from '../../constants/contentAnalytics';
import { getAttributeParameters } from '../../utils/helpers';
var ParametersFrame = function (renderProps) {
    var uiBlock = renderProps.uiBlock, contextPlugins = renderProps.contextPlugins, contentInstances = renderProps.contentInstances, contentAnalyticsProps = renderProps.contentAnalyticsProps, historicalQueries = renderProps.historicalQueries, updateUiBlock = renderProps.updateUiBlock;
    var _a = (contentAnalyticsProps === null || contentAnalyticsProps === void 0 ? void 0 : contentAnalyticsProps.contentData.methods) || {}, handleContentSearch = _a.handleContentSearch, handleContentOptionClick = _a.handleContentOptionClick, fetchNextContentPage = _a.fetchNextContentPage;
    var _b = (contentAnalyticsProps === null || contentAnalyticsProps === void 0 ? void 0 : contentAnalyticsProps.componentData.methods) || {}, handleComponentSearch = _b.handleComponentSearch, handleComponentOptionClick = _b.handleComponentOptionClick, fetchNextComponentsPage = _b.fetchNextComponentsPage;
    var _c = __read(useState(), 2), componentOptions = _c[0], setComponentOptions = _c[1];
    var PARAMS_CLASS = 'rule-params';
    var FIELD_WIDTH = '150px';
    var DROPDOWN_WIDTH = '350px';
    var COMPONENT_ENGAGED_NAME_IDX = 2;
    var COMPONENT_FULFILLED_NAME_IDX = 1;
    var historicalQueriesOptions = historicalQueries === null || historicalQueries === void 0 ? void 0 : historicalQueries.map(function (option) {
        return {
            key: option.id,
            name: "".concat(option.name, " (").concat(option.id, ")"),
        };
    });
    var isCtxHistoryResultAttribute = uiBlock.category === 'ctxhistory' && uiBlock.attributeName === 'result';
    var isComponentEngaged = uiBlock.category === 'contentAnalytics' && uiBlock.attributeName === 'componentEngaged';
    var isComponentFulfilled = uiBlock.category === 'contentAnalytics' && uiBlock.attributeName === 'componentFulfilled';
    var errorMessage = (!historicalQueries || historicalQueries.length === 0) && isCtxHistoryResultAttribute
        ? 'No historical queries present'
        : 'Value must not be empty';
    var getOptions = function (params) {
        return params.map(function (param) {
            var _a;
            if ((_a = param.valueTypeOptions) === null || _a === void 0 ? void 0 : _a.length) {
                var _options_1 = [{ key: '*', name: 'Any' }];
                param.valueTypeOptions.map(function (opt) {
                    if (opt.value) {
                        _options_1.push({
                            key: opt.value,
                            name: opt.value || opt.displayName,
                        });
                    }
                });
                return _options_1;
            }
            else {
                return [];
            }
        });
    };
    var getInstances = function (instances) {
        var _a;
        return ((_a = instances === null || instances === void 0 ? void 0 : instances.map(function (instance) {
            return {
                key: instance.id,
                name: instance.localizations.en.name,
            };
        })) !== null && _a !== void 0 ? _a : []);
    };
    var _d = __read(useState(false), 2), isError = _d[0], setIsError = _d[1];
    var _e = __read(useState(getAttributeParameters(uiBlock, contextPlugins)), 2), attributeParameters = _e[0], setAttributeParameters = _e[1];
    var _f = __read(useState(getOptions(attributeParameters)), 2), paramOptions = _f[0], setParamOptions = _f[1];
    var contentInstancesOption = getInstances(contentInstances);
    var _g = __read(useState(function () {
        var _a;
        var retVal = [];
        if (isCtxHistoryResultAttribute) {
            // remove 'any' as a value - must select a query
            if (!uiBlock.parameterValues || uiBlock.parameterValues[0] === '*') {
                uiBlock.parameterValues = [];
            }
            else if (!historicalQueriesOptions || historicalQueriesOptions.length === 0) {
                return [''];
            }
            else {
                var selectedQuery = historicalQueriesOptions.find(function (option) {
                    return option.key === uiBlock.parameterValues[0];
                });
                if (selectedQuery !== undefined)
                    return [selectedQuery];
            }
        }
        (_a = uiBlock.parameterValues) === null || _a === void 0 ? void 0 : _a.forEach(function (item, i) {
            var _a, _b, _c;
            if ((_a = paramOptions[i]) === null || _a === void 0 ? void 0 : _a.length) {
                retVal.push((_c = (_b = paramOptions[i]) === null || _b === void 0 ? void 0 : _b.find(function (option) {
                    return option.key === item;
                })) !== null && _c !== void 0 ? _c : { key: '*', name: 'Any' });
            }
            else if (isComponentEngaged || isComponentFulfilled) {
                if (item === '*' && i === 0) {
                    retVal.push('');
                }
                else {
                    retVal.push(item);
                }
            }
            else {
                if (item === '*') {
                    retVal.push('');
                }
                else {
                    retVal.push(item);
                }
            }
        });
        return retVal;
    }), 2), paramValues = _g[0], setParamValues = _g[1];
    var _h = __read(useState(function () {
        var retVal = [];
        paramValues.forEach(function (item, i) {
            retVal.push(false);
        });
        return retVal;
    }), 2), errorList = _h[0], setErrorList = _h[1];
    var checkIfEmpty = function (id) {
        var isErrorValue = isError;
        var errorListArray = errorList;
        if (paramValues[id] === '') {
            errorListArray[id] = true;
            isErrorValue = true;
        }
        else {
            errorListArray[id] = false;
        }
        setErrorList(errorListArray);
        setIsError(isErrorValue);
    };
    var checkIfContentAnalyticsQuery = function (value, key) {
        if (value && key === 'contentID' && CONTENT_ANALYTICS_QUERY_NAMES.includes(value)) {
            return true;
        }
        return false;
    };
    var checkIfContentAnalyticsComponentQuery = function (value, key) {
        if (value && key === 'componentID' && CONTENT_ANALYTICS_COMPONENT_QUERY_NAMES.includes(value)) {
            return true;
        }
        return false;
    };
    var getSelectedInstance = function (list, value) {
        if (value) {
            for (var count = 0; count < list.length; count++) {
                var currentValue = list[count];
                if (typeof value === 'string' && currentValue.key === value) {
                    return currentValue;
                }
                else if (currentValue.key === (value === null || value === void 0 ? void 0 : value.key)) {
                    return currentValue;
                }
            }
        }
        return null;
    };
    var handleInputChange = function (value, type, idx) {
        var _a;
        var pVal = '';
        if (type === 'int') {
            pVal = parseInt(value);
            // lmao this is ghetto af
            if (isNaN(pVal))
                pVal = value;
        }
        else
            pVal = value;
        var isContentChange = idx === 0 && (isComponentEngaged || isComponentFulfilled);
        var isErrorValue = false;
        var errorListArray = errorList;
        setParamValues(function (oldValuesArray) {
            return oldValuesArray.map(function (item, i) {
                if (i === idx) {
                    if (pVal === '') {
                        errorListArray[i] = true;
                        isErrorValue = true;
                    }
                    else {
                        errorListArray[i] = false;
                    }
                    return pVal;
                }
                else {
                    if (item === '') {
                        errorListArray[i] = true;
                        isErrorValue = true;
                    }
                    else {
                        errorListArray[i] = false;
                    }
                    return isContentChange ? '' : item;
                }
            });
        });
        setErrorList(errorListArray);
        setIsError(isErrorValue);
        if (pVal === '')
            pVal = '*';
        updateUiBlock(__assign(__assign({}, uiBlock), { parameterValues: (_a = uiBlock === null || uiBlock === void 0 ? void 0 : uiBlock.parameterValues) === null || _a === void 0 ? void 0 : _a.map(function (val, i) {
                return i === idx ? pVal : isContentChange ? '*' : val;
            }) }));
    };
    var handleDropdownChange = function (option, index) {
        var _a;
        setParamValues(function (oldValuesArray) {
            return isCtxHistoryResultAttribute
                ? [option]
                : oldValuesArray.map(function (item, i) {
                    return i === index ? option : item;
                });
        });
        updateUiBlock(__assign(__assign({}, uiBlock), { parameterValues: isCtxHistoryResultAttribute
                ? [option.key]
                : (_a = uiBlock === null || uiBlock === void 0 ? void 0 : uiBlock.parameterValues) === null || _a === void 0 ? void 0 : _a.map(function (val, i) {
                    return i === index ? option.key : val;
                }) }));
    };
    useEffect(function () {
        setAttributeParameters(getAttributeParameters(uiBlock, contextPlugins));
    }, [contextPlugins]);
    useEffect(function () {
        setParamOptions(getOptions(attributeParameters));
    }, [attributeParameters]);
    useEffect(function () {
        if (isCtxHistoryResultAttribute)
            setIsError(!(paramValues === null || paramValues === void 0 ? void 0 : paramValues[0]));
    }, [paramValues]);
    useEffect(function () {
        if (contentAnalyticsProps.componentData.nodeId === uiBlock.nodeId) {
            setComponentOptions(contentAnalyticsProps.componentData.data.options);
        }
    }, [contentAnalyticsProps.componentData, uiBlock.parameterValues]);
    var debouncedContentSuggestionSearch = useMemo(function () {
        return debounce(function (searchVal) {
            if (handleContentSearch) {
                handleContentSearch(searchVal);
            }
        }, 500);
    }, [handleContentSearch]);
    var debouncedComponentSuggestionSearch = useMemo(function () {
        return debounce(function (searchVal) {
            var _a;
            setComponentOptions(((_a = contentAnalyticsProps.componentData.data.options) === null || _a === void 0 ? void 0 : _a.filter(function (option) { var _a; return (_a = option.name) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(searchVal.toLowerCase()); })) || []);
            if (handleComponentSearch)
                handleComponentSearch(searchVal);
        }, 500);
    }, [contentAnalyticsProps.componentData.data.options]);
    // Trigger user type in Search bar from listing dropdown
    var handleContentSuggestionSearch = useCallback(function (searchVal) {
        debouncedContentSuggestionSearch(searchVal);
    }, []);
    var handleComponentSuggestionSearch = useCallback(function (searchVal) {
        debouncedComponentSuggestionSearch(searchVal);
    }, [componentOptions]);
    // Trigger only suggestion item selected from listing dropdown
    var handleSuggestedContentClick = useCallback(function (option, type, idx, paramType) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var selectedValue = ((_a = option === null || option === void 0 ? void 0 : option.payload) === null || _a === void 0 ? void 0 : _a.id) || ((_b = option.payload) === null || _b === void 0 ? void 0 : _b.componentID) || '';
        if (paramType === 'content') {
            handleInputChange(selectedValue, type, idx);
            if (handleContentOptionClick)
                handleContentOptionClick(option);
        }
        else {
            var newParamValues = [paramValues[0] || ((_c = option.payload) === null || _c === void 0 ? void 0 : _c.contentID), (_d = option.payload) === null || _d === void 0 ? void 0 : _d.componentID];
            // Extra params for componentEngaged attribute
            if (isComponentEngaged && ((_e = option.payload) === null || _e === void 0 ? void 0 : _e.componentName)) {
                newParamValues.push((_f = option.payload) === null || _f === void 0 ? void 0 : _f.componentName);
            }
            if (isComponentEngaged && ((_g = option.payload) === null || _g === void 0 ? void 0 : _g.componentType)) {
                newParamValues.push((_h = option.payload) === null || _h === void 0 ? void 0 : _h.componentType);
            }
            setParamValues(newParamValues);
            updateUiBlock(__assign(__assign({}, uiBlock), { parameterValues: newParamValues }));
            // If a component is selected, empty error should disappear
            if (errorList[idx]) {
                var errorListArray = errorList;
                errorListArray[idx] = false;
                setErrorList(errorListArray);
                setIsError(false);
            }
            if (handleComponentOptionClick)
                handleComponentOptionClick(option);
        }
    }, [handleContentOptionClick, handleComponentOptionClick, uiBlock]);
    // Trigger only user click outside of Listting box
    // Look if value is empty
    var handleContentListingBoxClickOutside = function (id) {
        checkIfEmpty(id);
    };
    // Render Suggestion list - for now, only used for content and component
    var renderSuggestionlist = useCallback(function (parameter, type, uid) {
        var _a, _b, _c;
        var isRenderingContent = type === 'content';
        var intro = {
            icon: isRenderingContent ? 'security' : 'puzzle',
            text: isRenderingContent ? "any ".concat(type, " name") : "select a ".concat(type),
        };
        var placeHolder = "search for a ".concat(type, " name");
        var remainingProps = isRenderingContent
            ? contentAnalyticsProps === null || contentAnalyticsProps === void 0 ? void 0 : contentAnalyticsProps.contentData.data
            : __assign(__assign({}, contentAnalyticsProps === null || contentAnalyticsProps === void 0 ? void 0 : contentAnalyticsProps.componentData.data), { options: componentOptions, disabled: !paramValues[0], onFocus: function () {
                    return contentAnalyticsProps.handleComponentsDropdownFocus(uiBlock.nodeId, paramValues[0].toString(), uid);
                } });
        var selected = null;
        if (isRenderingContent) {
            selected =
                ((_a = remainingProps.options) === null || _a === void 0 ? void 0 : _a.find(function (option) {
                    var _a;
                    return ((_a = option.payload) === null || _a === void 0 ? void 0 : _a.id) === paramValues[0];
                })) || null;
        }
        else if (!remainingProps.disabled) {
            var selectedName = isComponentEngaged
                ? (_b = paramValues[COMPONENT_ENGAGED_NAME_IDX]) === null || _b === void 0 ? void 0 : _b.toString()
                : (_c = paramValues[COMPONENT_FULFILLED_NAME_IDX]) === null || _c === void 0 ? void 0 : _c.toString();
            selected = {
                name: selectedName === '*' ? 'Any Component' : selectedName,
                subText: [],
            };
        }
        return (React.createElement(FlightSuggestionList, __assign({ className: "".concat(PARAMS_CLASS, "__paramItem"), selected: selected, hasError: errorList[parameter.index], handleClickOutside: function () {
                handleContentListingBoxClickOutside(parameter.index);
            }, handleSearch: function (searchVal) {
                if (isRenderingContent) {
                    handleContentSuggestionSearch(searchVal);
                }
                else {
                    handleComponentSuggestionSearch(searchVal);
                }
            }, handleOptionClick: function (option) {
                handleSuggestedContentClick(option, parameter.valueType, parameter.index, type);
            }, fetchNextPage: isRenderingContent ? fetchNextContentPage : fetchNextComponentsPage, intro: intro, searchPlaceholder: placeHolder }, remainingProps)));
    }, [contentAnalyticsProps, errorList, componentOptions, paramValues, handleSuggestedContentClick]);
    // Render Text input
    var renderTextInput = useCallback(function (parameter) {
        var _a;
        return (React.createElement(FlightTextInput, { className: "".concat(PARAMS_CLASS, "__paramItem"), label: "Any", hasClearIcon: true, onChange: function (e) {
                handleInputChange(e.target.value, parameter.valueType, parameter.index);
            }, value: (_a = paramValues[parameter.index]) === null || _a === void 0 ? void 0 : _a.toString(), width: FIELD_WIDTH, onBlur: function (e) { return checkIfEmpty(parameter.index); }, hasError: errorList[parameter.index] }));
    }, [paramValues, errorList, uiBlock]);
    // Render Select option
    var renderSelect = useCallback(function (idx, className, options, selected, width) {
        return (React.createElement(FlightSelect, { className: "".concat(PARAMS_CLASS, "__").concat(className), options: options, selected: selected, handleOptionClick: function (option) { return handleDropdownChange(option, idx); }, width: width || DROPDOWN_WIDTH }));
    }, [uiBlock]);
    return (attributeParameters === null || attributeParameters === void 0 ? void 0 : attributeParameters.length) !== 0 ? (React.createElement("div", { className: PARAMS_CLASS }, attributeParameters === null || attributeParameters === void 0 ? void 0 :
        attributeParameters.map(function (parameter, idx) {
            var _a;
            var isContentAnalytics = checkIfContentAnalyticsQuery(uiBlock === null || uiBlock === void 0 ? void 0 : uiBlock.ctxAttributeUid, parameter.key);
            var isDependency = uiBlock.type === 'dependency' && uiBlock.dependencyType === 'content';
            var contextVariable = "ctx.flybits.".concat(uiBlock.category, ".query.").concat(uiBlock.attributeName);
            var isContentSupportListing = checkIfContentAnalyticsQuery(contextVariable, parameter.key);
            var isContentAnalyticsComponent = checkIfContentAnalyticsComponentQuery(contextVariable, parameter.key);
            var isHistoricalresult = uiBlock.category === 'ctxhistory' && uiBlock.attributeName === 'result';
            var isValueTypeOptionsAvailable = (_a = parameter === null || parameter === void 0 ? void 0 : parameter.valueTypeOptions) === null || _a === void 0 ? void 0 : _a.length;
            var disabled = isContentAnalyticsComponent && paramValues[0] === '';
            // Avoid displaying input boxes for extra componentEngaged parameters
            if (isComponentEngaged && !isContentAnalyticsComponent && !isContentSupportListing)
                return false;
            // Remove content selector for dependency type
            if (isDependency) {
                return (React.createElement("em", { key: parameter.index },
                    React.createElement("small", null, "* This rule depends on the content engagement from a previous step")));
            }
            return (React.createElement("div", { key: parameter.index, className: "".concat(PARAMS_CLASS, "__container") },
                React.createElement("span", { className: "".concat(PARAMS_CLASS, "__paramName").concat(disabled ? "__disabled" : '') },
                    React.createElement("b", null, parameter.key)),
                isContentAnalytics ? (contentInstancesOption ? (renderSelect(idx, 'paramItem', contentInstancesOption, getSelectedInstance(contentInstancesOption, paramValues[idx]))) : (React.createElement("span", { className: "".concat(PARAMS_CLASS, "__error") },
                    React.createElement("b", null, "No Content created.")))) : isHistoricalresult ? (renderSelect(idx, 'ctxHistoryResultParamItem', historicalQueriesOptions, paramValues[idx])) : isValueTypeOptionsAvailable ? (renderSelect(idx, 'paramItem', paramOptions[idx], paramValues[idx], FIELD_WIDTH)) : isContentSupportListing ? (renderSuggestionlist(parameter, 'content', contextVariable)) : isContentAnalyticsComponent ? (renderSuggestionlist(parameter, 'component', contextVariable)) : (renderTextInput(parameter))));
        }),
        isError && React.createElement("span", { className: "".concat(PARAMS_CLASS, "__container flight-select__error-message") }, errorMessage))) : (React.createElement(React.Fragment, null));
};
export default ParametersFrame;
//# sourceMappingURL=ParametersFrame.js.map